// Shared between the two enrollment entry points (Flow 1's /invite/:token
// redemption and Flow 3's practitioner signup-code redemption) and
// ProtocolCard, which owns the actual consent dialog. Setting this flag is
// how either flow says "open the consent ask immediately on next Home
// mount" instead of leaving it as the quiet tap-to-review card.
const KEY = "haiven_open_practitioner_consent";

export function markPendingConsent() {
  try { sessionStorage.setItem(KEY, "1"); } catch { /* private mode */ }
}

export function consumePendingConsent() {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) sessionStorage.removeItem(KEY);
    return !!v;
  } catch {
    return false;
  }
}
